import { render } from "./RippleButton.vue?vue&type=template&id=903ccdbc"
import script from "./RippleButton.vue?vue&type=script&lang=js"
export * from "./RippleButton.vue?vue&type=script&lang=js"

import "./RippleButton.vue?vue&type=style&index=0&id=903ccdbc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__